import { render, staticRenderFns } from "./yearWorkscore.vue?vue&type=template&id=0b6bc6c7&scoped=true"
import script from "./yearWorkscore.vue?vue&type=script&lang=js"
export * from "./yearWorkscore.vue?vue&type=script&lang=js"
import style0 from "./yearWorkscore.vue?vue&type=style&index=0&id=0b6bc6c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6bc6c7",
  null
  
)

export default component.exports